import React from 'react';
import { GlobalStyles } from '@mui/material';

const BLUR_CLASS = 'global-blur';
const ROOT_ELEMENT_ID = 'root';

const globalStyles = (
    <GlobalStyles
        styles={{
            [`.${BLUR_CLASS}`]: {
                filter: 'blur(2px)',
                opacity: 0.75
            }
        }}
    />
);

/**
 * Dialogs nest — an award's details open on top of the awards sheet — so the blur is reference
 * counted. Closing the inner dialog would otherwise clear the class while the outer one is still
 * open, leaving the page sharp behind it.
 */
let openCount = 0;

const acquireBlur = () => {
    openCount += 1;
    document.getElementById(ROOT_ELEMENT_ID)?.classList.add(BLUR_CLASS);
};

const releaseBlur = () => {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
        document.getElementById(ROOT_ELEMENT_ID)?.classList.remove(BLUR_CLASS);
    }
};

interface BackgroundBlurProps {
    open?: boolean;
}

/**
 * Blurs the page behind a modal while it is open. The modal itself is portalled outside the app
 * root, so it stays sharp. Render this alongside any dialog that should sit over a blurred page.
 */
export const BackgroundBlur: React.FC<BackgroundBlurProps> = ({ open }) => {
    React.useEffect(() => {
        if (!open) {
            return undefined;
        }
        acquireBlur();
        return releaseBlur;
    }, [open]);

    return globalStyles;
};
